// ONE canonical slug for a card title.
//
// Used everywhere a title becomes part of a URL or a DOM lookup: the static
// share pages (/s/{slug}.html), the per-card OG images (/og/{slug}.png), the
// ?s= deep-link matcher, and the data-card-slug scroll targets. The frontend
// (CRA/webpack), the build scripts (plain node), and the Vercel api/ functions
// all load this file, so it is intentionally dependency-free CommonJS, keep it
// that way so every environment can require/import it.
//
// It strips characters that are ugly or fragile in bare-link shares (quotes
// and apostrophes, straight AND curly, commas, dollar signs), lowercases, and
// turns whitespace into underscores. Run it on BOTH sides of any comparison so
// old links (which still carry an apostrophe) keep matching the stripped slug.
function slugify(title) {
  return String(title)
    .replace(/[‘’“”]/g, '') // curly ' ' " "
    .replace(/["',$]/g, '')                     // straight " ' , and $
    .replace(/\s+/g, '_')                       // whitespace runs -> _
    .replace(/_+/g, '_')                        // collapse repeated _
    .replace(/^_+|_+$/g, '')                    // trim leading/trailing _
    .toLowerCase();
}

module.exports = { slugify };
